import React from 'react';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';

import Spacer from 'core/spacer/Spacer';
import Button from 'core/buttons/Button';
import ServerWarningSvg from 'assets/svg/server-warning.svg';

import app from 'app/config/app';
import { buildRoute } from 'routes';

const Wrapper = styled(Box)(({ theme }) => ({
  height: '100vh',
  width: '100vw',
  zIndex: 999,
  background: theme.palette.grey[100],
  display: 'grid',
  placeItems: 'center'
}));

const Content = styled(Box)(({ theme }) => ({
  display: 'grid',
  placeItems: 'center',
  gap: theme.spacing(1)
}));

export default function LinkExpired({ title, message }) {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Content>
        <img src={ServerWarningSvg} />
        <Spacer />
        {title && (
          <Typography variant="h5" color="primary.light" fontWeight={600}>
            {title}
          </Typography>
        )}
        {message && <Typography color="grey.600">{message}</Typography>}
        {app.supportEmail && <Typography>{app.supportEmail}</Typography>}
        <Spacer />
        <Button
          size="medium"
          onClick={() => navigate(buildRoute('login'))}
          sx={{ textTransform: 'none' }}
        >
          Goto Login
        </Button>
      </Content>
    </Wrapper>
  );
}

LinkExpired.defaultProps = {
  title: 'Link expired',
  message: 'Your link has already expired. Please  contact our support to get help.'
};
